import type { CompleteStoreFragment } from '@drycut/graphql';

import { StoreWaitingTime } from '@drycut/controlled-components';
import { Para, Stack } from '@drycut/ui-components';
import { MAX_MINUTES_TO_DISPLAY } from '@drycut/ui-format-utils';

import StylistList from '../../BookingStepper/Steps/StylistList';

type Props = {
  store: CompleteStoreFragment;
};

export default function WaitingTimeDetails({ store }: Props): React.ReactElement {
  const longerWait = store.waitingTime > MAX_MINUTES_TO_DISPLAY * 60;

  return (
    <Stack gap={2}>
      <Stack gap={1}>
        {!longerWait ? (
          <Para size="sm" pretty>
            Der nächste verfügbare Cut in
          </Para>
        ) : (
          <Para size="sm">Nächster freier Termin:</Para>
        )}
        <StoreWaitingTime store={store} showCa showZero steps />
      </Stack>

      {!longerWait && <StylistList stylists={store.checkedInStylists} size="sm" />}
    </Stack>
  );
}
